(function ($) {
  (function () {
    'use strict';

    var skedgeMeBookingToolV1 = {
      iframe: $('#skedgemeIframe')
    };

    Drupal.behaviors.skedgeMeBookingToolV1 = {
      get: function (key) {
        return skedgeMeBookingToolV1[key];
      },

      set: function (key, val) {
        skedgeMeBookingToolV1[key] = val;
      },

      getSearchParameters: function () {
        var self = this;
        var prmstr = window.location.search.substr(1);

        return prmstr !== null && prmstr !== '' ? self.transformToAssocArray(prmstr) : {};
      },

      transformToAssocArray: function (prmstr) {
        var params = {};
        var prmarr = prmstr.split('&');

        for (var i = 0; i < prmarr.length; i++) {
          var tmparr = prmarr[i].split('=');

          params[tmparr[0]] = decodeURIComponent(tmparr[1]);
        }

        return params;
      },

      constructUrl: function (params, widgetUrl) {
        var self = this;

        params.storeId = params.id;
        delete params.id;

        // return widgetUrl + "#/bb-landing?" + $.param(params);
        return widgetUrl;
      },

      attach: function (context, settings) {
        var self = this;
        var iframe = self.get('iframe');
        var skedgeMeLocation = iframe.attr('data-src');
        var params = self.getSearchParameters();
        // var widgetUrl = "/" + skedgeMeLocation + "/bb-widget/";
        var widgetUrl = skedgeMeLocation;
        var url = self.constructUrl(params, widgetUrl);
        var headerHeight = $('.site-header').height();

        // hide scrollbars
        $('body, html').addClass('noscroll');

        // load the iframe
        iframe.attr('src', url).removeClass('hidden');

        // detect if device is iphone and add class to reduce iframe width
        var deviceOs = navigator.platform;
        // console.log("deviceOS", deviceOs);
        // alert(navigator.appVersion);

        if (deviceOs.length && (deviceOs === 'iPhone' || deviceOs === 'iPad')) {
          iframe.addClass('ios-device');
          // alert(navigator.platform);
        }

        // initialize iframeResizer
        iframe.iFrameResize({
          checkOrigin: false,
          log: false,
          scrolling: true,
          sizeHeight: true
        });

        // check for changes in window height
        $(window)
          .on(
            'resize',
            _.debounce(function () {
              // adding space to height of iframe in ipad
              if (deviceOs.length && deviceOs === 'iPad') {
                var newHeight = $(window).height() + 1200;

                iframe.height(newHeight);
                // alert(navigator.platform);
              } else {
                var newHeight = $(window).height() - headerHeight;

                iframe.height(newHeight);
              }
            }, 150)
          )
          .resize();
      }
    };
  })();
})(jQuery);
